import { Endpoints, Http, HttpService } from "@/infra/api";
import { OcppEvent, SessionEntity } from "@/domain/entities";
import { ActivityLog, Session } from "@/domain/models";
import { ApiResponse, ApiQuery, SessionDTO, EncodeTypes } from "@/@types";
import usePermission from "../composables/usePermission";

export interface SessionRepository {
  getSession: (id: string) => Promise<ApiResponse<Session>>;
  getSessions: (query?: ApiQuery) => Promise<ApiResponse<Session[]>>;
  forceConclude: (
    id: string,
    params: SessionDTO
  ) => Promise<ApiResponse<Session>>;
  getOcppEvents: (query?: ApiQuery) => Promise<ApiResponse<ActivityLog[]>>;
}

export const SessionService = (
  http: Http = HttpService()
): SessionRepository => ({
  getSession: async (id) => {
    const res = await http.get<SessionEntity>(`${Endpoints.sessions}/${id}`);
    const data = new Session(res.data);
    return { ...res, data };
  },
  getSessions: async (query) => {
    const res = await http.get<SessionEntity[]>(Endpoints.sessions, query);
    const data = res.data?.length
      ? res.data.map((session) => new Session(session))
      : [];
    return { ...res, data };
  },
  forceConclude: async (id, params) => {
    const res = await http.post<SessionDTO, SessionEntity>(
      `${Endpoints.sessions}/${id}/force-conclude`,
      params
    );
    const data = new Session(res.data);
    return { ...res, data };
  },
  getOcppEvents: async (query) => {
    if (!usePermission().userHasPermission('chargers:ocppEvents:list')) return Promise.resolve({ status: true, data: [] })
    const res = await http.get<OcppEvent[]>(Endpoints.ocpp_events, query);
    const data = res.data?.length
      ? res.data.map((session) => new ActivityLog(session))
      : [];
    return { ...res, data };
  },
});
